var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"goback-button",attrs:{"href":_vm.searchUrl}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "),_c('span',[_vm._v("Tillbaka till överblick")])])}
var staticRenderFns = []

export { render, staticRenderFns }